import { Product } from './types.ts';
import { GraphComponent, IGraph, ILabel, INode, INodeStyle } from '@yfiles/yfiles';
import { Pseudo3DNodeStyle, SupportedNodeStyle } from './Pseudo3DNodeStyle.ts';
import { Pseudo3DLabelStyle } from './Pseudo3DLabelStyle.ts';

export function getRevenue(product: Product) {
  let revenue = 1;
  try {
    revenue = parseInt(product.Revenue);
  } catch (e) {
    console.error('unable to parse revenue from product', product, 'returning 1');
  }
  return revenue;
}

export function getOrientation(graphComponent: GraphComponent): {
  rotation: number;
  inclination: number;
} {
  return (graphComponent as any).orientation;
}

export function wrapInto3DStyle(graph: IGraph, item: INode | ILabel): void {
  if (item instanceof INode && !(item.style instanceof Pseudo3DNodeStyle)) {
    graph.setStyle(item, new Pseudo3DNodeStyle(item.style as SupportedNodeStyle));
  } else if (item instanceof ILabel && !(item.style instanceof Pseudo3DLabelStyle)) {
    graph.setStyle(item, new Pseudo3DLabelStyle(item.style));
  }
}

export function unwrap3DStyle(graph: IGraph, item: INode | ILabel): void {
  if (item instanceof INode && item.style instanceof Pseudo3DNodeStyle) {
    graph.setStyle(item, (item.style as Pseudo3DNodeStyle).wrappedNodeStyle);
  } else if (item instanceof ILabel && item.style instanceof Pseudo3DLabelStyle) {
    graph.setStyle(item, item.style.wrappedLabelStyle);
  }
}
